import React from "react";
import { Navigate } from "react-router-dom";

// Guards protected screens and redirects unauthenticated users back to the public entry route.
const PrivateRoute = ({ isAuthenticated, children }) => {
  // Render the protected page tree only when the current session is authenticated.
  return isAuthenticated ? (
    <>{children}</>
  )
    // Redirect unauthenticated access attempts to the login/landing page.
    : <Navigate to="/" replace />;
};

export default PrivateRoute;
